import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.manufacturerState
    ? { ...initialState, ...state.manufacturerState }
    : initialState;

export const selectManufacturersLoading = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.loading
);

export const selectManufacturersReordering = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.reordering
);

export const selectManufacturersList = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.list
);

export const selectManufacturersMeta = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.meta
);

export const selectManufacturersPage = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.page
);

export const selectManufacturersPerPage = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.perPage
);

export const selectManufacturerForm = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.form
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.isAddModalOpen
);

export const selectSelectedId = createSelector(
  [selectDomain],
  (manufacturerState) => manufacturerState.selectedId
);
